/** @jsx jsx */
import { jsx } from  '@emotion/core'
import NumberFormat from 'react-number-format';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import t from '../i18n'
import { Table, Select, Row, Col, DatePicker, Button, Space } from 'antd';

import removeTrailingZeros from 'remove-trailing-zeros'

import React, { Component } from 'react';
import { ReloadOutlined, FileExcelOutlined } from '@ant-design/icons'
import StockLocations from './stock_locations'
import { VariantList } from './VariantList';
import StockHistory from './stock_history'


const ReportTypes = (props) => {

  return(
    // <Select
    //   labelInValue
    //   defaultValue={{ value: props.defaultValue.value }}
    //   style={{ width: 120 }}
    //   onChange={props.handleChange}
    // >
    //   <Option value="jack">Jack (100)</Option>
    //   <Option value="lucy">Lucy (101)</Option>
    // </Select>
    <Select
      labelInValue
      style={{ width: 200 }}
      placeholder="Select a stock type"

      onChange={props.onChange}
      defaultValue={props.defaultValue}
    >
      <Select.Option value="purchases">Purchases</Select.Option>
      <Select.Option value="transfers">Transfers</Select.Option>
      <Select.Option value="opening_stock">Opening Stock</Select.Option>
    </Select>
  )
}


export default class StockMovements extends Component {
  constructor(props) {
    super(props);
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);

    this.state = {
      loading: true,
      data: [],
      stockLocations: [],
      selectedStockLocations: null,
      variantList: [],
      filteredInfo: null,
      columns: this.getColumns(),
      showInStock: true,
      variantData: {},
      showHistory: false,
      reportType: 'transfers',
      fromDate: moment( firstDay),
      toDate: moment(lastDay),
    }

    const that = this;
    this.dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const columns = that.state.columns;
        const item = columns.splice(fromIndex, 1)[0];
        columns.splice(toIndex, 0, item);
        that.setState({
          columns
        });
      },
      nodeSelector: "th"
    };

    
  }

  componentDidMount = () => {
    this.loadData();
  }

  setDate = (type, date) => {
    this.setState({ [type]: date }, this.loadData)
    
  }

  loadData = (callback) => {
    const $this = this
    $this.setState({
      loading: true
    });
    let { selectedVariants, selectedStockLocations, fromDate, toDate } = this.state
    if(ifHasValue(selectedStockLocations)) selectedStockLocations = selectedStockLocations.map( l => l.id) //.join(",")

    const url = Biscraft.routes.api.stocks_path + "/movements" +
      "?variant_id=" + (selectedVariants ?? '') + "&stock_location_id=" + (selectedStockLocations ?? '') +
      "&from_date=" + (ifHasValue(fromDate) && ifHasValue(fromDate).format('ll')) + "&to_date=" + (ifHasValue(toDate) && ifHasValue(toDate).format('ll'))  

    $.ajax({
      type: "get",
      dataType: 'json',
      url: url ,
      data: {
        token: Spree.api_key
      },
      success: function (response) {
        $this.setState({
          loading: false,
          data: response.data,
          variants: response.variants,
          stockLocations: response.stock_locations,
        });

      },
      error: function (response, textStatus, errorThrown) {
        show_flash('error', response.responseText);
      },

    });
  }

  stockLocationChangedHandler = (locations) => {
    debugger
    this.setState({ selectedStockLocations: locations }, this.loadData)

  }

  variantChangedHandler = (variants) => {
    this.setState({ selectedVariants: variants }, this.loadData)
    
  }

  variantList = () => {
    return this.state.data.map((d) => ({ name: d.variant_name, id: d.variant_id}) )
  }

handleChange = (pagination, filters, sorter) => {

  this.setState({
    filteredInfo: filters,
    sortedInfo: sorter,
  });
};

loadHistory = (variantData, locationData) => {
  locationData = { id: window.global_stock_location_id}
  this.setState({ showHistory: true, variantData, locationData }) 

}

  
getColumns = (locations) => {

  // let { filteredInfo } = this.state;
   
  let cols = 
  [
    {
      title: <div className="text-right"> # </div> ,
      width: 50,
      render: (text, record, index) => index + 1
    },
    {
      title: t('item'),
      width: 250,
      align: "left",
      key: 'variant_name',

      render: (text, record) => <a className="pull-left" href="#" onClick={() => this.loadHistory(record)}> <span style={{fontSize: '0.7em'}}>{record.variant_name} </span> <span><br/>{record.variant_name_ar} </span> </a>
      },
      {
        title:  t('opening_stock') ,
        children: [
          {
            title: 'Qty',
            dataIndex: 'opening_stock',
            key: 'opening_stock',
            align: "right",
            width: 100,
          },
          {
            title: 'Cost',
            dataIndex: 'opening_cost',
            key: 'opening_cost',
            align: "right",
            width: 100,
          },
        ]
      },
      {
        title: t('in') ,
        children: [
          {
            title: 'Qty',
            dataIndex: 'in_qty',
            key: 'in_qty',
            align: "right",
            width: 100,
          },
          {
            title: 'Cost',
            dataIndex: 'in_cost',
            key: 'in_cost',
            align: "right",
            width: 100,
          },
        ]
      },
    {
      title: t('out'),
      children: [
        {
          title: 'Qty',
          dataIndex: 'out_qty',
          key: 'out_qty',
          align: "right",
          width: 100,
        },
        {
          title: 'Cost',
          dataIndex: 'out_cost',
          key: 'out_cost',
          align: "right",
          width: 100,
        },
      ]

    },
    {
      title: t('balance'),
      children: [
        {
          title: 'Qty',
          dataIndex: 'end_qty',
          key: 'end_qty',
          align: "right",
          width: 100,
        },
        {
          title: 'Cost',
          dataIndex: 'end_cost',
          key: 'end_cost',
          align: "right",
          width: 100,
        },
      ]

    }
  ]
  
  return cols;
  
  }

  refresh = () => {
    this.setState({ refreshing: true})
    this.loadData(() => { this.setState({ refreshing: false })})

  }

  switchData = (checked) => {
    if (checked ){
      this.setState({ showInStock: true }, () => this.loadData())
    }
    else{
     this.setState({ showInStock: false }, () => this.loadData())
    }
  }


  getDataColumns = () => {
    const { stockLocations } = this.state;
    let dCols = [
      { name: t('item'), totalsRowLabel: 'Totals:', filterButton: true },
      { name: t('qty'), totalsRowFunction: 'sum', filterButton: false },
    ];


    dCols = dCols.concat(stockLocations.map((loc) => ({ key: loc.id, name: loc.name, totalsRowFunction: 'sum', filterButton: true })));


    return [dCols];

  }

  downloadExcel = () => {
    const [columns] = this.getDataColumns()
    const data  = this.state.data

    const { stockLocations } = this.state;

    let rows = []
    
    data.forEach(d => {
      let row = [d.variant_name, 
      Object.keys(d.data).map((locId) => (parseFloat(d.data[locId]))).reduce((total, num) => total + num, 0.0)];
      stockLocations.forEach(sl => {
        const val = d.data[sl.id]
        row.push(val ? removeTrailingZeros(val) : null );
      })
      rows.push(row)
    })

  


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Trial Balance',
      {
        views: [{ showGridLines: false }],
        headerFooter: { firstHeader: "Trial Balance", firstFooter: "Biscraft Powered" },
        style: {
          font: {
            name: 'Calibri',
            family: 4,
            size: 16,
          }
        },
      }
    );
    // worksheet.properties.defaultRowHeight = 15;
    // worksheet.getCell('A1').note = 'Hello, ExcelJS!';
    const table = worksheet.addTable({
      name: 'Stock Movement report',
      displayName: 'Stock Report As On ' + moment(this.state.date).format('lll'),
      ref: 'A1',
      headerRow: true,
      totalsRow: true,
      width: 50,

      style: {
        // theme: 'TableStyleDark3',
        showRowStripes: true,
        font: {
          name: 'Calibri',
          family: 4,
          size: 30,
          underline: true,
          bold: true
        }
      },
      columns ,
      rows,
    });

    const font = { name: 'Calibri', size: 12 };

    var nameCol = worksheet.getColumn(1);
    var typeCol = worksheet.getColumn(2);
    var debitCol = worksheet.getColumn(3);
    var creditCol = worksheet.getColumn(4);

    // [nameCol, typeCol, debitCol, creditCol].forEach(col => {
    //   col.width = 25;
    //   col.font = font;
    // });
    nameCol.width = 40;
    nameCol.alignment = { wrapText: true };

    // debitCol.eachCell(function (cell, rowNumber) {
    //   // ...
    // });
    debitCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    creditCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    table.commit();


    const filename = 'trial_balance_';
    return workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], {
        type: "application/octet-stream"
      }), `${filename}-${moment().format('YYYY-MM-DD__HH:mm:ss')}.xlsx`);
    });
  }

  render() {
    // alert(_global_currency_code)
    const { data, stockLocations, selectedStockLocations, columns } = this.state

    return (
      <div>

        <StockHistory 
          historyItems = {[1,2,3,4]}
          showHistory= {this.state.showHistory}
          onClose={ () => this.setState({ showHistory: false })}
          variantData = { this.state.variantData }
          locationData = { this.state.locationData }
        />
        
        <Row gutter={14} style={{marginBottom: '10px'}}>
          <Col span={3}>
            <DatePicker placeholder={t('from_date')} defaultValue={this.state.fromDate} 
              onChange={(val) => this.setDate('fromDate',  val)} />
          </Col>
          <Col span={3}>
            <DatePicker placeholder={t('to_date')} defaultValue={this.state.toDate}  
              onChange={(val) => this.setDate('toDate', val) }  />
          </Col>
          <Col span={6}>
            <StockLocations
              StockLocationChanged={this.stockLocationChangedHandler}
              stockLocations={stockLocations}
            />
          </Col>
          <Col span={6}>
            <VariantList
              VariantChanged={this.variantChangedHandler}
              variantList={this.variantList()}
            />
          </Col>  
          <Col span={6}>
            <Space>
              {/* <ReportTypes 
                defaultValue={{ value: this.state.reportType }}
                onChange={(e) => {  this.setState({ reportType: e.value })}}
              /> */}
               

              <Button disabled={! data?.length > 0 } onClick={this.downloadExcel} icon={<FileExcelOutlined />} type="primary" > Download </Button>

              <Button loading={this.state.refreshing} onClick={this.refresh} icon={<ReloadOutlined  />}></Button>
            </Space>
          </Col>          
          
        </Row>
          
                      
          <Table 
            columns={ columns} 
            dataSource={data} 
            pagination={false}
            size = {"small"}
            bordered
            loading = {this.state.loading}
            rowKey="variant_id"
          />


      </div>
    )
  }
}









